// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Nx-JA","text":"Card_text__TBJ3T","points":"Card_points__vBput","multiple":"Card_multiple__yAcSY","disabled":"Card_disabled__YO4of"};